import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';
import { LocaleContext } from 'components/rebrand/Layout';

import { ISectionWithCardList } from 'typescriptDefs/pages/home';

import { afTrackingByPage } from 'helpers/getAfTracking';

const Security = ({ cards, cta, heading }: ISectionWithCardList) => {
  const locale = useContext(LocaleContext);
  return (
    <Section className="py-56 md:py-80">
      <Container className="px-32 xs:px-0">
        <div className="mb-48 text-primary-400 md:mb-64 md:text-center md:[&>*]:mx-auto [&_p]:text-lg md:[&_p]:w-2/5 md:[&_p]:text-xl">
          <CustomPortableText
            headingStyles={{
              h1: { className: 'mb-24 md:mb-32', size: '2xl', as: 'h2' },
            }}
            content={heading}
          />
        </div>
        {!!cta && (
          <GetKOHOBtn
            className="mt-24 block md:mt-32"
            buttonLocation="Security section"
            queryParams={afTrackingByPage('HOME', cta.registrationAdsetId)}
            trackEventProps={{
              category: 'www page Home',
              label: 'Security',
              locale,
              location: 'Security section',
            }}
          />
        )}
        <div className="grid gap-16 md:grid-cols-3 md:gap-32">
          {cards.map(({ content: { description, heading, image }, cta }, i) => {
            const location = 'Security card - ' + cta?.registrationAdsetId;
            return (
              <div className="rounded-16 bg-primary-50 p-32" key={i}>
                <GatsbyImage className="mb-32 h-32 w-32" image={image.img.asset.gatsbyImageData} alt={image.altText} />
                <div
                  className={twMerge(
                    clsx(
                      '[&>*]:mb-16 [&_p]:text-xl [&_p]:font-bold [&_p]:leading-gripped [&_p]:text-primary-400 md:[&_p]:text-xl',
                      '[&_h3]:text-[30px] [&_h3]:leading-none md:[&_h3]:text-5xl',
                    ),
                  )}
                >
                  <CustomPortableText content={heading} />
                </div>
                <div className="text-primary-400 md:[&_p]:text-lg">
                  <CustomPortableText content={description} />
                </div>
                {!!cta && (
                  <GetKOHOBtn
                    className="mt-16 block md:mt-32"
                    buttonLocation={location}
                    queryParams={afTrackingByPage('HOME', cta.registrationAdsetId)}
                    trackEventProps={{
                      category: 'www page Home',
                      label: 'Security card',
                      locale,
                      location,
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </Container>
    </Section>
  );
};

export default Security;
